'use strict';
import { Map } from 'immutable';

function DataSource (data, dictionary) {
  this.id = data.get('id');

  this.applicationId = data.get('applicationId');
  this.application = this.applicationId ? dictionary.getApplication(this.applicationId) : null;

  this.feedId = data.get('feedId');
  this.feed = this.feedId ? new Map({
    id: this.feedId,
    url: 'https://admin.mlsn.ru/import/manage/view?feed_id=' + this.feedId
  }) : null;

  this.cianSource = this.id === 402 ? dictionary.getDataSource(this.id) : null;
}
const proto = DataSource.prototype;

proto.getId = function () {
  return this.id;
};

proto.getApplication = function () {
  return this.application || null;
};

proto.getFeed = function () {
  return this.feed || null;
};

proto.getCianSource = function () {
  return this.cianSource || null;
};

export default DataSource;



// WEBPACK FOOTER //
// ./src/classes/announcement/dataSource.js